import {
    FETCH_USER_INFO_SUCCESS_ACTION,
    FETCH_NEWSLETTER_SUCCESS_ACTION,
    FETCH_LANGUAGE_SUCCESS_ACTION,
    UPDATE_LANGUAGE_SUCCESS_ACTION,
    UPDATE_LANGUAGE_FAILURE_ACTION,
    UPDATE_LANGUAGE_START_PENDING_ACTION,
    UPDATE_LANGUAGE_STOP_PENDING_ACTION,
    EDIT_USER_SUCCESS_ACTION,
    EDIT_USER_START_PENDING_ACTION,
    EDIT_USER_STOP_PENDING_ACTION,
    FETCH_MESSAGES_SUCCESS_ACTION,
} from '../actions/settingsActions';
import { prefixMessages } from '../lang/languageData';

const enGBMessages = require('../lang/usersettings_en-GB.json');

export const initialState = {
    userInfo: {
        firstName: '',
        lastName: '',
        email: '',
    },
    userInfoPending: false,
    newsletter: {
        subscribed: false,
        subscriptionDate: '',
    },
    language: {
        locale: 'en-GB',
        messages: prefixMessages(enGBMessages),
        isPending: false,
        error: '',
    },
};

function handleFetchUserInfoSuccessAction(state, userInfo) {
    const newState = { ...state };
    newState.userInfo = userInfo;

    return newState;
}

function handleFetchNewsletterSuccessAction(state, newsletter) {
    const newState = { ...state };
    newState.newsletter = newsletter;

    return newState;
}

function handleFetchLanguageSuccessAction(state, language) {
    const newState = { ...state };
    newState.language.locale = language;

    return newState;
}

function handleUpdateLanguageResultAction(state, errorCode) {
    const newState = { ...state };
    newState.language.error = errorCode;
    return newState;
}

function handleUpdateLanguagePendingAction(state, isPending) {
    const newState = { ...state };
    newState.language.isPending = isPending;
    return newState;
}

function handleFetchMessagesSuccessAction(state, messages) {
    const newState = { ...state };
    newState.language.messages = prefixMessages(messages);
    return newState;
}

function handleEditUserSuccessAction(state, userInfo) {
    const newState = { ...state };
    newState.userInfo = userInfo;

    return newState;
}

function handleEditUserStartPendingAction(state) {
    const newState = { ...state };
    newState.userInfoPending = true;

    return newState;
}

function handleEditUserStopPendingAction(state) {
    const newState = { ...state };
    newState.userInfoPending = false;

    return newState;
}

export default function settingsReducer(state = initialState, action = {}) {
    switch (action.type) {
        case FETCH_USER_INFO_SUCCESS_ACTION:
            return handleFetchUserInfoSuccessAction(state, action.payload);
        case FETCH_NEWSLETTER_SUCCESS_ACTION:
            return handleFetchNewsletterSuccessAction(state, action.payload);
        case EDIT_USER_SUCCESS_ACTION:
            return handleEditUserSuccessAction(state, action.payload);
        case EDIT_USER_START_PENDING_ACTION:
            return handleEditUserStartPendingAction(state);
        case EDIT_USER_STOP_PENDING_ACTION:
            return handleEditUserStopPendingAction(state);
        case FETCH_LANGUAGE_SUCCESS_ACTION:
            return handleFetchLanguageSuccessAction(state, action.payload);
        case UPDATE_LANGUAGE_SUCCESS_ACTION:
            return handleUpdateLanguageResultAction(state, '');
        case UPDATE_LANGUAGE_FAILURE_ACTION:
            return handleUpdateLanguageResultAction(state, action.payload);
        case FETCH_MESSAGES_SUCCESS_ACTION:
            return handleFetchMessagesSuccessAction(state, action.payload);
        case UPDATE_LANGUAGE_START_PENDING_ACTION:
            return handleUpdateLanguagePendingAction(state, true);
        case UPDATE_LANGUAGE_STOP_PENDING_ACTION:
            return handleUpdateLanguagePendingAction(state, false);
        default:
            return { ...state };
    }
}
